import React from "react";
import PropTypes from "prop-types";
import AriaModal from "react-aria-modal";
import styles from "./styles.module.scss";

const Modal = ({ open, title, onClose, children }) => (
  <AriaModal
    mounted={open}
    onExit={onClose}
    dialogClass={styles.dialog}
    underlayClass={styles.underlay}
    dialogStyle={{ height: "auto" }}
    focusDialog
    escapeExits={false}
    underlayClickExits={false}
    includeDefaultStyles={false}
    titleText={title}
  >
    <div
      className={styles.modalHeader}
      data-testid="auto-dialer-modal-header"
    >
      <h1 data-testid="auto-dialer-modal-title">
        {title}
      </h1>
      <button
        className={styles.closeButton}
        aria-label="Close modal"
        onClick={onClose}
        data-testid="auto-dialer-modal-close-button"
      >
        ✖
      </button>
    </div>

    {children}
  </AriaModal>
);

Modal.displayName = "Modal";

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

Modal.defaultProps = {
  open: false,
};

export default Modal;
